module.exports = __webpack_public_path__ + "img/star.bcb344a6.svg";